import Nav from "../components/general/NavBar.jsx";
import Footer from "../components/general/footer";
import TypebotFrame from "../components/general/TypebotFrame.jsx";

const Satisfaction = () => {
  return (
    <section>
      <Nav />
      <div style={{ width: "100%", minHeight: "600px" }}>
        <TypebotFrame slug="u-p-4-mind-satisfaction-client-beneficiaires-et-entreprises-ea53keo"/>
      </div>
      <Footer border="contact" />
    </section>
  );
};

export default Satisfaction;